// #MapShapes — Trazado propio de áreas y rutas. Google retiró DrawingManager
// en Maps JS 3.65: crearlo lanza un error y tumba la página.

export const MIN_SHAPE_POINTS = { polygon: 3, polyline: 2 };

// Un doble click dispara antes dos clicks en el mismo punto: se descartan los
// vértices consecutivos repetidos.
export function dedupePath(path) {
  return (path || []).filter((pt, i, all) => i === 0
    || Math.abs(pt.lat - all[i - 1].lat) > 1e-7 || Math.abs(pt.lng - all[i - 1].lng) > 1e-7);
}

export function canFinishShape(type, path) {
  return dedupePath(path).length >= (MIN_SHAPE_POINTS[type] || Infinity);
}
